export default "__VITE_ASSET__Rejo_Euu__"